export const AdvertisementEndpoints = Object.freeze({
  stories: (page: number) => `/v3/advertisement/stories?page=${page}`,
  banner: '/v3/advertisement/banner'
})
